var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMMapDashboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.37 3.82L8.18.55 0 3.82v19.63l8.18-3.27 8.18 3.27L24 20.18V.55zm-7.69-2l7.18 2.88v17.48L8.68 19.3zM1 4.5l6.68-2.68V19.3L1 22zm22 15l-6.14 2.63V4.69L23 2.06z"
  })));
}
export default SvgMMapDashboard;